;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import React from "react"
import { MessageGlyph } from "./glyphs"
import { UI_STYLE_PRIMARY_BLUE_BLACK } from "../../../../../lib/constants"

export default function MessagesIcon({ style }: { style?: React.CSSProperties }) {
  return (
    <MessageGlyph
      style={{
        width: 21,
        height: 22,
        color: UI_STYLE_PRIMARY_BLUE_BLACK,
        ...style,
      }}
    />
  )
}
